import {NO_SUB_SEQUENCE} from 'session/constants.js';
import AutomationPoint from 'parameters/AutomationPoint.js';
import {
    deleteSelection,
} from 'session/operations/actions.js';
import {dispatch} from 'session/operations/dispatch.js';
import {setAutomationPointsSelected} from 'actions/index.js';
import {pasteSelection} from 'session/operations/actions.js';
import {
    pastePianoRollPattern,
    duplicatePianoRollPattern,
       } from 'session/operations/actions.js';
import {duplicateSelection} from 'session/operations/actions.js';
import {getStepFromPosition} from './getStepFromPosition.js';
import {SUB_SEQUENCE_VOLUME_CHANGE} from 'session/constants.js';
import {ARRANGEMENT_TRACK_PATTERN} from 'session/constants.js';

export function copy(state) {
    let rowSelections = state.rowSelections;
    if (isRowSelectionsEmpty(rowSelections)) {
        return {
            selectedEvents: state.selectedEvents,
        };
    }

    return {
        rowSelections: rowSelections,
    };
}

export function getStepToPaste(sequencerEngine) {
    let state = sequencerEngine.state;
    return state.arrangement.cursorStep;
}

function getMixFromId(sequencerEngine, id) {
    return id === NO_SUB_SEQUENCE.id ?
        sequencerEngine.mix :
        sequencerEngine.getSubSequence(id).mix;
}

export function paste(sequencerEngine, copyRing) {
    let step = getStepToPaste(sequencerEngine);
    if (step !== undefined) {
        if (copyRing.rowSelections) {
            for (let id in copyRing.rowSelections) {
                if (isTrack(sequencerEngine, id)) {
                    pasteTrackAutomation(step, sequencerEngine, copyRing.rowSelections[id], id);
                    return;
                }
                let mix = getMixFromId(sequencerEngine, id);
                let automationType = getAutomationType(sequencerEngine, id);
                let eventType = undefined;
                if (automationType === SUB_SEQUENCE_VOLUME_CHANGE &&
                    Object.keys(copyRing.rowSelections).length === 1) {
                    eventType = SUB_SEQUENCE_VOLUME_CHANGE;
                }

                let selectedSubSequence = getSelectedSubSequence(sequencerEngine);
                let track = undefined;
                if (selectedSubSequence && selectedSubSequence.isTrack) {
                    track = selectedSubSequence.tracks[0];
                }
 
                mix.dispatch(pasteSelection(step, copyRing.rowSelections[id], eventType, track));
            }
        }
        if (copyRing.selectedEvents) {
            for (let id in copyRing.selectedEvents) {
                if (id === ARRANGEMENT_TRACK_PATTERN) {
                    // todo: paste multiple events and paste events
                    // that aren't track
                    let selectedSubSequence = getSelectedSubSequence(sequencerEngine);
                    if (selectedSubSequence.isTrack) {
                        let track = selectedSubSequence.tracks[0];
                        dispatch(
                            undefined,
                            pastePianoRollPattern(track, copyRing.selectedEvents[id], step));
                    }
                }
            }
        }
    }
}

export function duplicate(sequencerEngine) {
    let copyRing = copy(sequencerEngine.state.arrangement);

    if (copyRing.rowSelections !== undefined) {
        for (let id in copyRing.rowSelections) {
            let mix = getMixFromId(sequencerEngine, id);
            
            let automationType = getAutomationType(sequencerEngine, id);
            let eventType = undefined;
            if (automationType === SUB_SEQUENCE_VOLUME_CHANGE &&
                Object.keys(copyRing.rowSelections).length === 1) {
                eventType = SUB_SEQUENCE_VOLUME_CHANGE;
            }
            mix.dispatch(duplicateSelection(copyRing.rowSelections[id], eventType));
            
        }
    }

    if (copyRing.selectedEvents !== undefined) {
        for (let id in copyRing.selectedEvents) {
            if (id === ARRANGEMENT_TRACK_PATTERN) {
                // todo: paste multiple events and paste events
                // that aren't track
                let selectedSubSequence = getSelectedSubSequence(sequencerEngine);
                if (selectedSubSequence.isTrack) {
                    let track = selectedSubSequence.tracks[0];
                    dispatch(
                        undefined,
                        duplicatePianoRollPattern(track, copyRing.selectedEvents[id]));
                }
            }
        }
    }
}

function getAutomationType(sequencerEngine, id) {
    let state = sequencerEngine.state;
    return state.arrangement.automationTypeToShow[id];
}

export function isRowSelectionsEmpty(rowSelections) {
    for (let i in rowSelections) {
        if (rowSelections[i].end > rowSelections[i].start) {
            return false;
        }
    }
    return true;
}

function getSelectedSubSequence(sequencerEngine) {
    let state = sequencerEngine.state;
    let row = state.arrangement.selectedRows[0];
    if (row === undefined) {
        return undefined;
    }

    return sequencerEngine.getSubSequence(row);
}

const isTrack = (sequencerEngine, id) => {
    // look for all the tracks 
    for (let sub of sequencerEngine.subSequences) {
        let track = sub.tracks.find(track => track.id === id);
        if (track) {
            return track;
        }
    }
    return undefined;
};

const pasteTrackAutomation = (step, sequencerEngine, {start, end}, id) => {
    let parameter = selectedParameter(sequencerEngine, sequencerEngine.getSelectedTrack().id);
    if (!parameter) {
        // only can paste from selected parameter
        return;
    }

    // copy the automation parameters wewe want
    let copiedEvents = getSelectedAutomations(sequencerEngine, {start, end}, id)
        .map(x => x.getCopy(false));

    let offset = step - start;
    copiedEvents.forEach(
        e => e.step += offset);

    // get first and last events
    let startPt =
        new AutomationPoint(
            step,
            parameter.mixAutomation.getValueAtStep(start));
    let endPt = new AutomationPoint(
        step + (end - start),
        parameter.mixAutomation.getValueAtStep(end));

    // add them to list
    copiedEvents.push(startPt);
    copiedEvents.push(endPt);


    // now add them to the list of events (with the
    // events overlapping the goal paste region removed)
    parameter.mixAutomation.automations = [
        ... parameter.mixAutomation.automations.filter(
            a => a.step < step || a.step > step + (end - start)), 
        ... copiedEvents];

    parameter.mixAutomation.automations.sort(
        (a,b) => a.step - b.step);

    parameter.mixAutomation.updateRedux();

    sequencerEngine.dispatch(
        setAutomationPointsSelected(id, []));
};

export const getSelectedAutomations = (sequencerEngine, {start, end}, id) => {
    let parameter = selectedParameter(sequencerEngine, id);
    if (!parameter) {
        // only can paste from selected parameter
        return [];
    }

    return parameter.mixAutomation.automations.
        filter(automation => automation.step >= start &&
               automation.step <= end);
};

export const selectedParameter = (sequencerEngine, id) => {
    return sequencerEngine.state.automation.trackParameter[id];
}

export const deleteRowSelections = (sequencerEngine, rowSelections) => {
    for (let id in rowSelections) {
        if (isTrack(sequencerEngine, id)) {
        } else {
            getMixFromId(sequencerEngine, id).dispatch(
                deleteSelection(rowSelections[id]));
        }
    }
};
